// src/store/rootSaga.ts
import { all } from 'redux-saga/effects';
import { authSaga } from 'store/auth/sagas';
import { ordersSaga } from './orders/sagas';
import { productSaga } from './products/sagas';
import { categoriesSaga } from './categories/sagas';
import { usersSaga } from './users/saga';
import { offersSaga } from './offers/sagas';
import { reviewsSaga } from './reviews/sagas';
import { advertisementsSaga } from './advertisements/sagas';
import { langingImageSaga } from './landing-images/sagas';
import { rolesSaga } from './roles/saga';
import { subscriptionsSaga } from './subscriptions/saga';
import { inquriesSaga } from './inquiries/sagas';
import { settingSaga } from './settings/saga';
import { dashboardSaga } from './dashboard/sagas';
import { couponsSaga } from './coupons/sagas';

export function* rootSaga() {
  yield all([
    authSaga(),
    ordersSaga(),
    productSaga(),
    categoriesSaga(),
    usersSaga(),
    offersSaga(),
    couponsSaga(),
    advertisementsSaga(),
    langingImageSaga(),
    reviewsSaga(),
    rolesSaga(),
    subscriptionsSaga(),
    inquriesSaga(),
    settingSaga(),
    dashboardSaga(),
  ]);
}
